import { ReactElement, createContext, lazy, useEffect, useMemo } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router';

import { RootState, useAppDispatch, useAppSelector } from '../../redux/store';
import { fetchAuthType } from '../../redux/Auth/actions';
import { HomeRoutes } from '../../Routing/RouteConstants';
import AppLoading from '../../Modules/Home/HomeLayouts/AppLoading';
import NotSetup from 'Modules/NotSetup/NotSetup';
import { LoadingIndicator } from '@components/LoadingIndicatorMaterial';
import RouteErrorPage from '@components/ErrorBoundary/RouteErrorPage';

const TermsAndConditions = lazy(
  () => import('../../Modules/Home/TermsAndConditions/TermsAndConditions')
);
const HomeLayoutLoginRoutes = lazy(
  () => import('../../Modules/Home/HomeLayouts/HomeLayoutLoginRoutes')
);

export const AuthTypeContext = createContext<null>(null);

type Props = {
  children: ReactElement<any>;
};

const AuthTypeProvider = ({ children }: Props) => {
  const dispatch = useAppDispatch();

  const isAdminLogin = useMemo(() => {
    return window.location.pathname.includes(HomeRoutes.adminLogin);
  }, []);

  const isLoading = useAppSelector((state: RootState) => state.userInfo.authTypeIsLoading);
  const hasError = useAppSelector((state: RootState) => state.userInfo.authTypeHasError);

  useEffect(() => {
    dispatch(fetchAuthType());
  }, [dispatch]);

  const { Provider } = AuthTypeContext;

  if (isLoading) {
    return <AppLoading />;
  }

  if (hasError && !isAdminLogin) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<NotSetup />} />
          <Route
            path={HomeRoutes.terms}
            hydrateFallbackElement={<LoadingIndicator isLoading />}
            errorElement={<RouteErrorPage />}
            lazy={async () => {
              return { element: <HomeLayoutLoginRoutes content={<TermsAndConditions />} /> };
            }}
          />
        </Routes>
      </BrowserRouter>
    );
  }
  return <Provider value={null}>{children}</Provider>;
};

export default AuthTypeProvider;
